import { lazy, Suspense } from 'react';
import type { CodeEditorProps } from './CodeEditor';
import { EditorSkeleton } from './EditorSkeleton';

const CodeEditor = lazy(() => import('./CodeEditor'));

/** Preload Monaco (e.g. on hover/focus of a "Continue" link). */
export function preloadEditor() {
  void import('./CodeEditor');
}

export function LazyCodeEditor(props: CodeEditorProps) {
  return (
    <Suspense fallback={<EditorSkeleton />}>
      <CodeEditor {...props} />
    </Suspense>
  );
}
